/* eslint-disable no-unused-vars */
// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import store from "@store";
import { wdConfigData } from "@/service/wd_app_config.js";

// util
import {
  insert_slide_byTemplateFile,
  getOnePageTemplateById,
  addProductLogandTxt
} from "./gpt_addin_utils.js";

// VSTO Host Object
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");

var PowerPoint = window.PowerPoint;

export async function add_slide_classic_canvas(generateContent) {
  // 先随机选取模版，插入模版
  let template = getOnePageTemplateById("template_one_page_classic_canvas");
  let templateUrl = `/${template.path}`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(
      `${wdConfigData.baseURLTemplate}/${templateUrl}`
    );
    await hostObject_shapes.vsto_updateSlideContent_ClassicCanvans(generateContent);
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await _updateSlideContent(generateContent);
    await addProductLogandTxt()
  }

  publish(
    gptPubIds.pubId_Local_Addin_SystemLog,
    i18n.t("ppt_addin.process.text_ppt_generating_ppt_onepage_success")
  );
}

async function _updateSlideContent(generateContent) {
  PowerPoint = window.PowerPoint
  let dataJson = JSON.parse(generateContent);
  // 更改模版中的内容
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;
  
      // shape数组数据
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();
  
        if (shape.name.startsWith("TextBox-Content")) {
          // shape text frame
          let textFrame = shape.textFrame;
          // text range
          textFrame.load("textRange", 'autoSizeSetting');
          await context.sync();
          textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape 
          await context.sync();
          let textRange = textFrame.textRange;
          textRange.load("$all");
          await context.sync();
  
          // 解析文本
          let content = "";
          let contentArray = [];
          switch (shape.name) {
            case "TextBox-Content-Key Partners":
              contentArray = dataJson["KeyPartners"];
              break;
            case "TextBox-Content-Key Activities":
              contentArray = dataJson["KeyActivities"];
              break;
            case "TextBox-Content-Key Resources":
              contentArray = dataJson["KeyResources"];
              break;
            case "TextBox-Content-Customer Relationships":
              contentArray = dataJson["CustomerRelationships"];
              break;
            case "TextBox-Content-Channels":
              contentArray = dataJson["Channels"];
              break;
            case "TextBox-Content-Value Propositions":
              contentArray = dataJson["ValuePropositions"];
              break;
            case "TextBox-Content-Customer Segments":
              contentArray = dataJson["CustomerSegments"];
              break;
            case "TextBox-Content-Cost Structure":
              contentArray = dataJson["CostStructure"];
              break;
            case "TextBox-Content-Revenue Streams":
              contentArray = dataJson["RevenueStreams"];
              break;
          }
          contentArray.forEach((item) => {
            content += item;
            content += "\r";
          });
  
          // 更改TextBox文本
          textRange.text = content;
          await context.sync();

          // textRange.load("font", "size", "italic", "color", "bold")
          // await context.sync()
          
          // var textRangeTextFont = textRange.font
          // textRangeTextFont.size = 14
          // await context.sync()
        }
      }
    });
  } catch (error) {
    console.log("_updateSlideContent");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}
